import { formatPrice } from "@/utils";
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Flex,
  IconButton,
  Image,
  Select,
  Spinner,
  Text,
  useBreakpointValue
} from "@chakra-ui/react";

import { TableCart } from "../Table";

export function ModalCart({ isOpen, onClose, cartItems }) {
  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  return (
    <Drawer isOpen={isOpen} onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent h="360px" w="" mt="22vh">
        <DrawerBody pt="10px">
          {cartItems ? (
            <Flex direction="column">
              {cartItems ? (
                <TableCart>
                  {cartItems.items.map((item) => {
                    return (
                      <Flex
                        key={item.productID}
                        width="full"
                        borderBottomWidth="1px"
                        borderBottomColor="gray.300"
                        borderBottomStyle="solid"
                        p="20px 0"
                        flexWrap={isWideVersion ? "nowrap" : "wrap"}
                      >
                        <Flex
                          flex={isWideVersion && 4}
                          width="full"
                          justifyContent="space-between"
                          pr={["0", "10px"]}
                          ml={["10px", "0"]}
                        >
                          <Flex alignItems="center">
                            <Image
                              src={item.urlImagemProduto}
                              alt={item.name}
                              borderColor="gray.300"
                              borderWidth="1px"
                              borderStyle="solid"
                              width={["60px", "auto"]}
                              mr="10px"
                              h={["60px", "auto"]}
                            />

                            <Text fontSize={["text1", "text1"]}>{item.name}</Text>
                          </Flex>
                          {isWideVersion && (
                            <IconButton
                              variant="outline"
                              colorScheme="whiteAlpha"
                              aria-label="Remover Produto"
                              icon={
                                <Image
                                  src="https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/geral/dropItem.svg"
                                  alt="Remover produto"
                                />
                              }
                            />
                          )}
                        </Flex>

                        <Flex
                          flex="1"
                          alignItems={["center", "flex-start"]}
                          pl="10px"
                          justifyContent="center"
                          direction="column"
                        >
                          {!isWideVersion && (
                            <Text fontSize="text3" my="15px">
                              Quantidade
                            </Text>
                          )}

                          <Flex>
                            {!isWideVersion && (
                              <Image
                                src="https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/geral/dropItem.svg"
                                alt="Remover"
                                mr="10px"
                              />
                            )}
                            <Select width="70px" borderRadius="0" defaultValue={item.qty}>
                              <option value={1}>1</option>
                              <option value={2}>2</option>
                              <option value={3}>3</option>
                              <option value={4}>4</option>
                              <option value={5}>5</option>
                              <option value={6}>6</option>
                              <option value={7}>7</option>
                              <option value={8}>8</option>
                            </Select>
                          </Flex>
                        </Flex>

                        <Flex
                          flex="1"
                          alignItems={["center", "flex-start"]}
                          justifyContent="center"
                          direction="column"
                        >
                          {!isWideVersion && (
                            <Text fontSize="text3" mb="20px">
                              Valor Unitário
                            </Text>
                          )}
                          <Text>{formatPrice(item.prices[0].value)}</Text>
                        </Flex>

                        <Flex
                          flex="1"
                          alignItems={["center", "flex-end"]}
                          justifyContent="center"
                          direction="column"
                        >
                          {!isWideVersion && (
                            <Text fontSize="text3" mb="20px">
                              Subtotal
                            </Text>
                          )}
                          <Text>{formatPrice(item.prices[0].value * item.qty)}</Text>
                        </Flex>
                      </Flex>
                    );
                  })}
                </TableCart>
              ) : (
                <Text>Carrinho Vazio</Text>
              )}

              <Flex direction="column" alignItems="flex-end" mt="0px">
                <Flex mb="40px" direction="column" width="250px">
                  <Flex width="100%" mb="5px">
                    <Flex flex="2" justifyContent="flex-end">
                      <Text fontSize="text3" alignItems="right">
                        Subtotal
                      </Text>
                    </Flex>
                    <Flex flex="3" justifyContent="flex-end">
                      <Text>{cartItems.subTotal}</Text>
                    </Flex>
                  </Flex>

                  <Flex width="100%" mb="5px">
                    <Flex flex="2" justifyContent="flex-end">
                      <Text fontSize="text3" alignItems="right">
                        Frete Rodoviário
                      </Text>
                    </Flex>
                    <Flex flex="3" justifyContent="flex-end">
                      <Text>{cartItems.totalFrete}</Text>
                    </Flex>
                  </Flex>

                  {cartItems.cupom ? (
                    <Flex width="100%" mb="5px">
                      <Flex flex="2" justifyContent="flex-end">
                        <Text fontSize="text3">{cartItems.couponDesc}</Text>
                      </Flex>
                      <Flex flex="3" justifyContent="flex-end">
                        <Text color="blue.900">- {cartItems.cupom.discount}</Text>
                      </Flex>
                    </Flex>
                  ) : null}

                  <Flex width="100%" mb="5px">
                    <Flex flex="2" justifyContent="flex-end">
                      <Text fontSize="text3" fontWeight="bold">
                        Total
                      </Text>
                    </Flex>
                    <Flex flex="3" justifyContent="flex-end">
                      <Text fontWeight="bold">{cartItems.total}</Text>
                    </Flex>
                  </Flex>
                </Flex>
              </Flex>
            </Flex>
          ) : (
            <Spinner size="xl" color="#1e1e1e" />
          )}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}
